import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import UserInfo from '@/components/UserInfo.vue';
    import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
    import { type SharedData, type User } from '@/types';
    import { usePage } from '@inertiajs/vue3';
    import { Link } from '@inertiajs/vue3';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'NavUser',
  setup(__props) {

    const page = usePage<SharedData>();
    const user = page.props.auth.user;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SidebarMenu), null, {
    default: _withCtx(() => [
      _createVNode(_unref(SidebarMenuItem), null, {
        default: _withCtx(() => [
          _createVNode(_unref(SidebarMenuButton), {
            "as-child": "",
            size: "lg",
            class: "data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground cursor-pointer",
            "is-active": _ctx.route('v2.profile.index') === _unref(page).props.ziggy.location
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Link), {
                href: _ctx.route('v2.profile.index')
              }, {
                default: _withCtx(() => [
                  _createVNode(UserInfo, { user: _unref(user) }, null, 8, ["user"])
                ]),
                _: 1
              }, 8, ["href"])
            ]),
            _: 1
          }, 8, ["is-active"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})